export default __webpack_public_path__ + "static/media/edit_user_forms_bg.586ffc6f.svg";